




















import { Component, Vue } from 'vue-property-decorator';
import MicrosoftIntegration from './MicrosoftIntegration.vue';

@Component({
    name: 'IntegrationsList',
    components: {
        MicrosoftIntegration,
    },
})
export default class IntegrationsList extends Vue {}
